import styled from 'styled-components';
const StyledSvgWrapper = styled.svg.attrs(() => {
    return {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        className: '_ndsIcon'
    };
}) `
  fill: ${(props) => props.color || 'inherit'};

  /* default width and height */
  /* when size is not specified */
  width: ${(props) => props.theme.SizeWidthIconMedium};
  height: ${(props) => props.theme.SizeHeightIconMedium};
  min-width: ${(props) => props.theme.SizeWidthIconMedium};
  min-height: ${(props) => props.theme.SizeHeightIconMedium};
  max-width: ${(props) => props.theme.SizeWidthIconMedium};
  max-height: ${(props) => props.theme.SizeHeightIconMedium};

  &._ndsIcon--small {
    width: ${(props) => props.theme.SizeWidthIconSmall};
    height: ${(props) => props.theme.SizeHeightIconSmall};
    min-width: ${(props) => props.theme.SizeWidthIconSmall};
    min-height: ${(props) => props.theme.SizeHeightIconSmall};
    max-width: ${(props) => props.theme.SizeWidthIconSmall};
    max-height: ${(props) => props.theme.SizeHeightIconSmall};
  }
  &._ndsIcon--medium {
    width: ${(props) => props.theme.SizeWidthIconMedium};
    height: ${(props) => props.theme.SizeHeightIconMedium};
    min-width: ${(props) => props.theme.SizeWidthIconMedium};
    min-height: ${(props) => props.theme.SizeHeightIconMedium};
    max-width: ${(props) => props.theme.SizeWidthIconMedium};
    max-height: ${(props) => props.theme.SizeHeightIconMedium};
  }
  &._ndsIcon--large {
    width: ${(props) => props.theme.SizeWidthIconLarge};
    height: ${(props) => props.theme.SizeHeightIconLarge};
    min-width: ${(props) => props.theme.SizeWidthIconLarge};
    min-height: ${(props) => props.theme.SizeHeightIconLarge};
    max-width: ${(props) => props.theme.SizeWidthIconLarge};
    max-height: ${(props) => props.theme.SizeHeightIconLarge};
  }
`;
export default StyledSvgWrapper;
//# sourceMappingURL=StyledSvgWrapper.js.map